import { MDataTable } from 'components/shared/MDataTable'
import { MDataTableColumns } from 'components/shared/MDataTable/type'
import { ADMIN_PREFIX_PATH } from 'config'
import useFetchPage2 from 'hooks/useFetchPage2'
import ListContentLayout from 'layout/ListContentLayout'
import moment from 'moment'
import { FC, useMemo, useState } from 'react'
import { NavigateFunction, useNavigate } from 'react-router'
import { useGlobal } from 'raducer/global'
import { toTitleCase } from 'utils/functions'
import CallDirectionAvatar from '../components/CallDirectionAvatar'
import CallRecordingCell from '../components/CallRecordingCell'
import NoCallsYetState from '../components/NoCallsYetState'
import VoiceEmptyState from '../components/VoiceEmptyState'
import { TCall } from '../types'
import {
 formatCallDuration,
 formatPhoneNumber,
 getCallTypeLabel,
} from '../utils'

const getColumns = (navigate: NavigateFunction): MDataTableColumns<TCall>[] => [
 {
  title: 'Name',
  dataIndex: 'contact_name',
  size: 260,
  render: (val, record) => {
   const number =
    record.direction === 'inbound' ? record.from_number : record.to_number
   const formattedNumber = formatPhoneNumber(number)
   return (
    <div className="d-flex align-items-center" style={{ columnGap: '10px' }}>
     <CallDirectionAvatar
      direction={record.direction}
      status={record.status}
      size={36}
     />
     <div
      {...(record.lead_id
       ? {
          role: 'button',
          style: { cursor: 'pointer' },
          onClick: () =>
           navigate(
            `${ADMIN_PREFIX_PATH}/leads/all-leads#lead-details/${record.lead_id}/profile`,
           ),
         }
       : {})}
     >
      <div>{toTitleCase(record.contact_name) || formattedNumber}</div>
      {record.contact_name && (
       <div className="text-muted" style={{ fontSize: '12px' }}>
        {formattedNumber}
       </div>
      )}
     </div>
    </div>
   )
  },
 },
 {
  title: 'Date',
  dataIndex: 'created_at',
  size: 180,
  render: (val) => moment(val).format('MMM DD, YYYY h:mm A'),
 },
 {
  title: 'Duration',
  dataIndex: 'duration',
  size: 100,
  render: (val) => formatCallDuration(val),
 },
 {
  title: 'Call Type',
  dataIndex: 'direction',
  size: 120,
  render: (val, record) => getCallTypeLabel(record.direction, record.status),
 },
 {
  title: 'Recording',
  dataIndex: 'has_recording',
  size: 130,
  render: (val, record) => <CallRecordingCell call={record} />,
 },
]

const CallsList: FC = () => {
 const [searchKey, setSearchKey] = useState('')
 const { global } = useGlobal()
 const enabled = global?.voice_enabled === true
 const navigate = useNavigate()
 const columns = useMemo(() => getColumns(navigate), [navigate])

 const { flatData, isLoading, hasMore, fetchMore, isRefetching, total } =
  useFetchPage2<TCall>('calls', {
   method: 'get',
   params: searchKey ? `search=${searchKey}` : '',
   //    enable: enabled,
  })

 return (
  <ListContentLayout title="Calls">
   {/* {!enabled ? (
    <VoiceEmptyState />
   ) : ( */}
   <MDataTable
    totalData={total || 1000}
    search={{
     placeholder: 'Search by name or number',
     onSearch: setSearchKey,
     show: true,
    }}
    loading={isLoading}
    isFetching={isRefetching}
    hasMore={hasMore}
    fetchMore={() => {
     fetchMore()
    }}
    data={flatData}
    columns={columns}
    emptyNode={!enabled ? <VoiceEmptyState /> : <NoCallsYetState />}
   />
   {/* )} */}
  </ListContentLayout>
 )
}

export default CallsList
